<!-- Notifications toggle -->
<button
    mat-icon-button
    (click)="openPanel()"
    #notificationsOrigin>
    <ng-container *ngIf="unreadCount > 0">
        <span class="absolute top-0 right-0 left-0 flex items-center justify-center h-3">
            <span class="flex items-center justify-center shrink-0 min-w-4 h-4 px-1 ml-4 mt-2.5 rounded-full bg-teal-600 text-indigo-50 text-xs font-medium">
                {{unreadCount}}
            </span>
        </span>
    </ng-container>
    <mat-icon [svgIcon]="'heroicons_outline:bell'"></mat-icon>
</button>

<!-- Notifications panel -->
<ng-template #notificationsPanel>

    <div class="fixed inset-0 sm:static sm:inset-auto flex flex-col sm:min-w-90 sm:w-90 sm:rounded-2xl overflow-hidden shadow-lg">

        <!-- Header -->
        <div class="flex flex-col"> <!-- Main flex container -->
            <div class="flex items-center justify-between py-4 pr-4 pl-6 bg-primary text-on-primary"> <!-- First row -->
                <div class="sm:hidden -ml-1 mr-3">
                    <button mat-icon-button (click)="closePanel()">
                        <mat-icon class="icon-size-5 text-current" [svgIcon]="'heroicons_solid:x'"></mat-icon>
                    </button>
                </div>
                <div class="text-lg font-medium leading-10">Notifications</div>
                <div class="ml-auto">
                    <button mat-icon-button [matTooltip]="'Mark all as read'" [disabled]="unreadCount === 0" (click)="markAllAsRead()">
                        <mat-icon class="icon-size-5 text-current" [svgIcon]="'heroicons_solid:mail-open'"></mat-icon>
                    </button>
                </div>
            </div>
            
            <div class="flex items-center justify-between" style="background-color: #0d9488;"> <!-- Second row for the search field -->
                <input [(ngModel)]="searchTerm" (ngModelChange)="applyFilter()" type="text" placeholder="Search..." class="ml-4 mr-4 mb-4 py-2 px-3 border border-gray-300 rounded-md w-full" style="color: white;"  />
                <!-- Add any search icon or button if needed -->
            </div>
        </div>
        
        


        

        <!-- Content -->
        <div class="relative flex flex-col flex-auto sm:max-h-120 divide-y overflow-y-auto bg-card">
            <!-- Notifications Loop -->
            <ng-container *ngFor="let notification of filteredResults; trackBy: trackByFn">
                <div 
                    class="flex group dark:hover:bg-black dark:hover:bg-opacity-5 hover:bg-gray-100"
                    [ngStyle]="{ 'background-color': !notification.read ? '#e9f6ff' : 'initial' }"
                >
                    <!-- Notification Link -->
                    <ng-container *ngIf="notification.link">
                        <a class="flex flex-auto py-5 pl-6 cursor-pointer" [href]="notification.link" *ngIf="!notification.useRouter">
                            <ng-container *ngTemplateOutlet="notificationContent"></ng-container>
                        </a>
                        <a class="flex flex-auto py-5 pl-6 cursor-pointer" [routerLink]="notification.link" *ngIf="notification.useRouter">
                            <ng-container *ngTemplateOutlet="notificationContent"></ng-container>
                        </a>
                    </ng-container>
        
                    <!-- Notification without a Link -->
                    <ng-container *ngIf="!notification.link">
                        <div class="flex flex-auto py-5 pl-6">
                            <ng-container *ngTemplateOutlet="notificationContent"></ng-container>
                        </div>
                    </ng-container>
        
                    <!-- Mark as Read Action -->
                    <div *ngIf="!notification.read" class="relative flex flex-col my-5 mr-4 ml-2">
                        <button class="w-6 h-6 min-h-6" mat-icon-button (click)="toggleRead(notification)" [matTooltip]="'Mark as read'">
                            <span class="w-2 h-2 rounded-full" 
                                [ngClass]="{'bg-gray-400 dark:bg-gray-500 sm:opacity-0 sm:group-hover:opacity-100': notification.read, 'bg-primary': !notification.read}">
                            </span>
                        </button>
                    </div>
                </div>
        
                <!-- Notification Content -->
                <ng-template #notificationContent>
                    <!-- Title and Event -->
                    <div class="flex flex-col flex-auto justify-center items-center">
                        <ng-container *ngIf="notification.title">
                            <div class="font-semibold line-clamp-3 text-lg" [innerHTML]="notification.title"></div>
                        </ng-container>
        
                        <div class="flex flex-col flex-auto justify-center items-center">
                            <!-- Dynamically choose which template to load -->
                            <ng-container *ngTemplateOutlet="getTemplateForNotification(notification); context: {data: notification}"></ng-container>
                        </div>
                        
                        <!-- Default Notification Template -->
                        <ng-template #defaultTemplate let-data="data">
                            <div *ngIf="data.terminal" class="line-clamp-1 text-lg" [innerHTML]="data.terminal"></div>
                            <div class="line-clamp-1 mb-4 mt-4">
                                <span class="bg-gray-200 text-blue-500 dark:bg-gray-600 dark:text-blue-50 inline-flex items-center text-xs px-2.5 py-0.5 rounded-full tracking-wide uppercase">
                                    <span class="leading-relaxed whitespace-nowrap line-clamp-1 text-lg">{{data.event}}</span>
                                </span>
                            </div>
                            <div class="flex flex-col items-center">
                                <div class="line-clamp-1 mb-2" [innerHTML]="'From: ' + formatDateTime(data.objectContent.oldValue, data.dataType)"></div>
                                <div class="line-clamp-1 text-blue-500 text-lg" [innerHTML]="'To: ' + formatDateTime(data.objectContent.newValue, data.dataType)"></div>
                            </div>
                        </ng-template>
                        
                        <!-- POB Entrance/Sailing Notification Template -->
                        <ng-template #pobTemplate let-data="data">
                            <div *ngIf="data.terminal" class="line-clamp-1 text-lg" [innerHTML]="data.terminal"></div>
                            <div class="flex flex-col items-center mb-4 mt-4">
                                <!-- Badge (POB Departure) -->
                                <span class="bg-blue-500 text-white dark:bg-blue-500 dark:text-white inline-flex items-center text-xs px-2.5 py-0.5 rounded-full tracking-wide uppercase">
                                    <span class="leading-relaxed whitespace-nowrap text-lg">{{data.event}}
                                    </span>
                                </span>
                                
                                <!-- Text (Inner Anchorage) Below the Badge, Centralized -->
                                <div *ngIf="data.objectContent.context.innerAnchorage" class="text-gray-500 italic text-md mt-1">
                                    Inner Anchorage
                                </div>
                            </div>
                            
                            <ng-container *ngIf="data.objectContent.oldValue; else noOldValue">
                                <div class="flex flex-col items-center">
                                    <div class="line-clamp-1 mb-2" [innerHTML]="'From: ' + formatDateTime(data.objectContent.oldValue, data.dataType)"></div>
                                    <div class="line-clamp-1 text-blue-500 text-lg" [innerHTML]="'To: ' + formatDateTime(data.objectContent.newValue, data.dataType)"></div>
                                </div>
                            </ng-container>
                            
                            <ng-template #noOldValue>
                                <div class="flex flex-col items-center">
                                    <div class="line-clamp-1 text-blue-500 text-lg" [innerHTML]="formatDateTime(data.objectContent.newValue, data.dataType)"></div>
            
                                </div>
                            </ng-template>
                        </ng-template>
                        
                        <!-- POB Cancelled Notification Template -->
                        <ng-template #pobCancelledTemplate let-data="data">
                            <div *ngIf="data.terminal" class="line-clamp-1 text-lg" [innerHTML]="data.terminal"></div>
                            <div class="line-clamp-1 mb-4 mt-4">
                                <span class="bg-red-500 text-white dark:bg-red-500 dark:text-white inline-flex items-center text-xs px-2.5 py-0.5 rounded-full tracking-wide uppercase">
                                    <span class="leading-relaxed whitespace-nowrap line-clamp-1 text-lg">
                                        {{data.event}}
                                        <mat-icon *ngIf="data.objectContent.context.direction == 'E'" matTooltip="Entrance" class="fa-solid fa-arrow-up-wide-short" style="font-size: 15px; color: white;"></mat-icon>
                                        <mat-icon *ngIf="data.objectContent.context.direction == 'S'" matTooltip="Sailing" class="fa-solid fa-arrow-down-wide-short" style="font-size: 15px; color: white;"></mat-icon>

                                    </span>
                                </span>
                            </div>
                            <div class="line-clamp-1 text-blue-500 text-lg" [innerHTML]="formatDateTime(data.objectContent.oldValue, data.dataType)"></div>
                        </ng-template>
                        
                        <!-- AutoChange Notification Template -->
                        <ng-template #autoChangeTemplate let-data="data">
                            <div *ngIf="data.terminal" class="line-clamp-1 text-lg" [innerHTML]="data.terminal"></div>
                            <div class="line-clamp-1 mb-4 mt-4">
                                <span class="bg-gray-200 text-blue-500 dark:bg-gray-600 dark:text-blue-50 inline-flex items-center text-xs px-2.5 py-0.5 rounded-full tracking-wide uppercase">
                                    <span [matTooltip]="'Previous: ' + formatDateTime(data.objectContent.previousValue, 0)" class="leading-relaxed whitespace-nowrap line-clamp-1 text-lg">{{data.event}}</span>
                                </span>
                            </div>
                            <div class="flex flex-col items-center">
                                <div class="line-clamp-1 mb-2" [innerHTML]="'From: ' + formatDateTime(data.objectContent.manualChangeValue, 0)"></div>
                                <div class="line-clamp-1 text-blue-500 text-lg" [innerHTML]="'To: ' + formatDateTime(data.objectContent.newValue, 0)"></div>
                            </div>
                        </ng-template>
        
                        <!-- Notification Type Indicator -->
                        <div [matTooltip]="notification.reason">
                            <span class="mt-8 inline-flex items-center font-bold text-xs px-2.5 py-0.5 rounded-full tracking-wide uppercase"
                                [ngClass]="{
                                    'bg-gray-200 text-gray-800 dark:bg-gray-600 dark:text-gray-50': notification.type === 'standard',
                                    'bg-amber-200 text-amber-800 dark:bg-amber-600 dark:text-amber-50': notification.type === 'custom',
                                    'bg-orange-200 text-orange-800 dark:bg-orange-600 dark:text-orange-50': notification.type === 'autochange'
                                }">
                                {{notification.type}}
                            </span>
                        </div>
        
                        <!-- Timestamp -->
                        <div class="mt-2 text-sm leading-none text-secondary">
                            {{notification.sentAt | date:'EEE dd/MMM HH:mm'}}
                        </div>
                    </div>
                </ng-template>
            </ng-container>
        
            <!-- No Notifications Message -->
            <ng-container *ngIf="!filteredResults || !filteredResults.length">
                <div class="flex flex-col flex-auto items-center justify-center sm:justify-start py-12 px-8">
                    <div class="flex flex-0 items-center justify-center w-14 h-14 rounded-full bg-primary-100 dark:bg-primary-600">
                        <mat-icon class="text-primary-700 dark:text-primary-50" [svgIcon]="'heroicons_outline:bell'"></mat-icon>
                    </div>
                    <div class="mt-5 text-2xl font-semibold tracking-tight">No notifications</div>
                    <div class="w-full max-w-60 mt-1 text-md text-center text-secondary">When you have notifications, they will appear here.</div>
                </div>
            </ng-container>
        </div>
        

    </div>

</ng-template>
